<template>
  <div class="home">
    <hero
      question="Magst du"
      question1="Blumen"
      question2="Frühlingsgefühle"
      question3="es wild?"
      claim="Prima! Wir finden, dass man Gefühle am besten mit einer originellen Geschenkidee ausdrücken kann."
      solution="Deshalb verschenkst du mit uns nicht bloß ganz klassisch einen Blumenstrauß voller roter Rosen zum Hochzeitstag. Sondern eine ganze Blühwiese mit so vielen Blumen, dass du sie gar nicht tragen könntest."
    />
    <textblock
      headline="Blumen zum Hochzeitstag? Na sicher, eine ganze Wilde Pracht!"
      column1="Jedes Jahr nur rote Rosen zum Hochzeitstag – das wird doch schnell langweilig! Mit der Wilden Pracht verschenkst du mehr Blumen, als du tragen kannst. Und weil sie alle auf dem Feld bleiben, gibt’s auch noch Bienen, Schmetterlinge und Libellen dazu. Zeige deinem Partner, wie wichtig er oder sie dir ist und dass du dir viele Gedanken über das passende Geschenk gemacht hast. Die Wilde Pracht eignet sich hervorragend als originelle Überraschung zum Hochzeitstag! Und das sogar, falls euch an dem Tag eine größere Entfernung trennt."
      column2="Übrigens: Auch wenn du den Hochzeitstag fast vergessen hättest, kannst du bei uns noch ganz schnell dein Geschenk organisieren. Die einjährige Blühpatenschaft ist in wenigen Minuten bereit zum Verschenken. Entscheide dich einfach unten, wie viele Quadratmeter du verschenken möchtest (Kleiner Tipp: Die Anzahl der Ehejahre bietet sich an) und fülle in drei Schritten unser Formular aus. Sofort bekommst du eine Bestellbestätigung und kannst dir deine Blühkarte herunterladen, die du zusätzlich per Post bekommst. Und mit der Bienenpost informieren wir euch beide die ganze Blühsaison über, was sich auf dem Blühstreifen so tut."
    />
    <cta
      title="Werde jetzt Pate für die Blühsaison 2025."
      subtitle="Und überrasche zum Hochzeitstag."
    />
    <Orderform />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import Textblock from "@/components/Textblock.vue";
import Cta from "@/components/Cta.vue";
import Orderform from "@/components/Orderform/Orderform.vue";

export default {
  name: "Hochzeitstag",
  components: {
    Hero,
    Textblock,
    Cta,
    Orderform,
  },
  metaInfo: {
    title: "Magst du Schmetterlinge im Bauch? | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Wir auch – vor allem auf dem Feld. Deshalb verschenkst du mit uns nicht bloß einen Blumenstrauß zum Hochzeitstag. Sondern Wildblumen auf dem Acker.",
      },
      {
        itemprop: "name",
        content: "Magst du Schmetterlinge im Bauch? | Wilde Pracht",
      },
      {
        property: "og:title",
        content: "Magst du Schmetterlinge im Bauch? | Wilde Pracht",
      },
      {
        itemprop: "description",
        content:
          "Wir auch – vor allem auf dem Feld. Deshalb verschenkst du mit uns nicht bloß einen Blumenstrauß zum Hochzeitstag. Sondern Wildblumen auf dem Acker.",
      },
      {
        property: "og:description",
        content:
          "Wir auch – vor allem auf dem Feld. Deshalb verschenkst du mit uns nicht bloß einen Blumenstrauß zum Hochzeitstag. Sondern Wildblumen auf dem Acker.",
      },
    ],
  },
};
</script>

<style lang="scss"></style>
